export const initialState = {
    loader: false,
    loaderLong: false,
    langPrefix:'',
    lang_id:1,
    contentData:{},
    aboutData:{},
    contactData:{},
    categoryNav:{
        categories:[],
        products:[]
    },
    navServices:[],
    services:[],
    otherServices:[],
    mainSlider:[],
    productsData:[],
    otherProducts:[],
    categoresData:[],
    thankyouletter:[],
    certificates:[],
    ourMission:{},
    partners:[],
    productsDataFooter:[],
    languages:[],
    lisences:[]
}
